/**
 * Gets the first element of the matched elements.
 *
 * @param {String} selector - the CSS selector to match
 * @return {Element}
 */
export default function getElement(selector) {
  const elements = Array(...document.querySelectorAll(selector));
  return elements[0];
}
